import { ShortCode } from '@highereducation/wordpress';
import { ImageCard } from '@highereducation/hen-ui';

type ImageBackgroundColor =
  | 'neutral-50'
  | 'neutral-100'
  | 'white'
  | 'transparent';
type ImageAspect = 'default' | 'video' | 'square';

const GRID_COL_SPAN: Record<string, string> = {
  '1': 'col-span-1',
  '2': 'col-span-2',
  '3': 'col-span-3',
  '4': 'col-span-4',
};

const GRID_ROW_SPAN: Record<string, string> = {
  '1': 'row-span-1',
  '2': 'row-span-2',
  '3': 'row-span-3',
};

/** Match BentoBoxCell: stack full-width on small screens, real spans from md up. */
const MOBILE_GRID_STACK = 'max-md:col-span-full max-md:row-span-1';

type ImageCardShortcodeProps = {
  'image-url': string;
  'image-alt': string;
  'img-class'?: string;
  'image-background-color'?: ImageBackgroundColor;
  'image-aspect'?: ImageAspect;
  variant?: 'default' | 'full-width';
  'col-span'?: string;
  'row-span'?: string;
  children?: React.ReactNode;
};

export const ImageCardShortcode: ShortCode<ImageCardShortcodeProps> = {
  component: ({
    'image-url': imageUrl,
    'image-alt': imageAlt,
    'img-class': imgClass,
    'image-background-color': imageBackgroundColor,
    'image-aspect': imageAspect,
    variant = 'default',
    'col-span': colSpan,
    'row-span': rowSpan,
    children,
  }) => {
    const colClass = colSpan ? GRID_COL_SPAN[colSpan] : undefined;
    const rowClass = rowSpan ? GRID_ROW_SPAN[rowSpan] : undefined;
    const gridWrapperClass = [MOBILE_GRID_STACK, colClass, rowClass, 'min-h-0']
      .filter(Boolean)
      .join(' ');

    const card = (
      <ImageCard
        imageUrl={imageUrl}
        imageAlt={imageAlt}
        variant={variant}
        imgClass={imgClass}
        imageBackgroundColor={imageBackgroundColor}
        imageAspect={
          imageAspect && imageAspect !== 'default' ? imageAspect : undefined
        }
      >
        {children}
      </ImageCard>
    );

    if (!colClass && !rowClass) {
      return card;
    }

    return <div className={gridWrapperClass}>{card}</div>;
  },
};
